import { useEffect, useRef, useState } from "react";
import { FlexRow, Circle, CustomContainer } from "src/style"
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io"

export const HorizontalScroll: React.FC<any> = ({children}) => {
    const [showPrev, setShowPrev] = useState(false);
    const [showNext, setShowNext] = useState(true);

    const scrollContainerRef = useRef<any>(null);

    useEffect(() => {
        const handleScroll = () => {
            const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
            setShowPrev(scrollLeft > 0);
            setShowNext(scrollLeft + clientWidth < scrollWidth);
        };
    
        const scrollContainer: any = scrollContainerRef.current;
        scrollContainer.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial check
    
        return () => {
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollLeft = () => {
        scrollContainerRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    };

    const scrollRight = () => {
        scrollContainerRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    };

    return (
        <FlexRow topMargin='1' gap='1.5' justifyContent='space-between'>
            { showPrev &&
                <Circle
                    size='4.4' borderColor='#ADB5BD'
                    style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                    onClick={scrollLeft}
                >
                    <IoIosArrowBack fontSize='1.6rem' fill='#344054' />
                </Circle>
            }
            <CustomContainer ref={scrollContainerRef} className='scrollable-container'>
                {children}
            </CustomContainer>
            { showNext &&
                <Circle
                    size='4.4' borderColor='#ADB5BD'
                    style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                    onClick={scrollRight}
                >
                    <IoIosArrowForward fontSize='1.6rem' fill='#344054' />
                </Circle>
            }
        </FlexRow>
    )
}